import React, { lazy, Suspense } from "react";
import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react";
import { injectMainStore } from "@cuba-platform/react";
import { ROUTES } from "../../mobile-routes";
import { Spin } from "@shared/antd/spin";

const PortalFeedbackQuestionsAnswerLazy = lazy(() => import("@entities/portal-feedback-questions-answer/ui/portal-feedback-questions-answer"));

type Props = RouteComponentProps<{ entityId?: string }>;

@injectMainStore
@observer
export class QuestionsItemManagement extends React.Component<Props> {
  static PATH = ROUTES.portalQuestionsItem.desktop;
  static NEW_SUBPATH = "new";

  render() {
    return (
      <>
        <Suspense fallback={<Spin spinning={true} />}>
          <PortalFeedbackQuestionsAnswerLazy/>
          {/*<IncomingFeedbackQuestionsPageLazy />*/}
        </Suspense>
        {/*{entityId ? (*/}
        {/*  <FeedbackQuestionsEdit entityId={entityId} />*/}
        {/*) : (*/}
        {/*)}*/}
      </>
    );
  }
}
